module.exports = __webpack_public_path__ + "img/THLLogo.f9ef9ce7.png";